/* Cœura nav interactions for the Shopify theme. Markup is server-rendered in header.liquid;
   this only wires behaviour (drawers, the live moon window, mobile menu, fades). */
(function () {
  'use strict';

  var moonState = null; // { open, line, color }

  /* ---- Drawers (§5) ---- */
  function wireDrawers() {
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var triggers = Array.prototype.slice.call(document.querySelectorAll('.nav-trigger'));
    var openTimer = null, closeTimer = null, current = null;

    function drawerOf(id) { return document.getElementById(id); }
    function trigOf(id) { return document.querySelector('.nav-trigger[data-drawer="' + id + '"]'); }

    function closeNow() {
      document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      current = null;
    }
    function openDrawer(id) {
      clearTimeout(closeTimer);
      if (current === id) return;
      closeNow();
      var d = drawerOf(id); if (!d) return;
      d.classList.add('is-open');
      var t = trigOf(id); if (t) t.setAttribute('aria-expanded', 'true');
      current = id;
    }
    function scheduleOpen(id) { clearTimeout(openTimer); openTimer = setTimeout(function () { openDrawer(id); }, 120); }
    function cancelOpen() { clearTimeout(openTimer); }
    function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(closeNow, 250); }
    function cancelClose() { clearTimeout(closeTimer); }

    triggers.forEach(function (t) {
      var id = t.getAttribute('data-drawer');
      var d = drawerOf(id);
      if (!coarse) {
        t.addEventListener('mouseenter', function () { scheduleOpen(id); });
        t.addEventListener('mouseleave', function () { cancelOpen(); scheduleClose(); });
        if (d) {
          d.addEventListener('mouseenter', cancelClose);
          d.addEventListener('mouseleave', scheduleClose);
        }
      }
      // a trigger with data-href navigates (e.g. Shop → all products); hover still opens its drawer
      t.addEventListener('click', function () {
        cancelOpen();
        var href = t.getAttribute('data-href');
        if (href) { window.location.href = href; return; }
        if (current === id) { closeNow(); } else { openDrawer(id); }
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          var href = t.getAttribute('data-href');
          if (href) { window.location.href = href; return; }
          if (current === id) { closeNow(); return; }
          openDrawer(id);
          var first = d && d.querySelector('a[href]');
          if (first) first.focus();
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) { var t = trigOf(current); closeNow(); if (t) t.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!current) return;
      if (e.target.closest('.drawer') || e.target.closest('.nav-trigger')) return;
      closeNow();
    });
    window.addEventListener('scroll', function () { if (current) closeNow(); }, { passive: true });
  }

  /* ---- The atelier tray (Drawer Addendum v1.1): hover a family/type → the stage swaps ----
     One .tray-stage per drawer (THE PIECES has #tray-stage, THE ATELIER has #tray-stage-world) —
     wired generically by class so both drawers share this one function instead of each needing
     its own copy. Each stage is scoped to its own drawer via closest('.drawer'). */
  function wireTray() {
    document.querySelectorAll('.tray-stage').forEach(function (stage) {
      var drawer = stage.closest('.drawer');
      if (!drawer) return;
      var views = {};
      stage.querySelectorAll('[data-stage]').forEach(function (v) { views[v.getAttribute('data-stage')] = v; });
      function show(key) {
        var target = views[key] || views.rest;
        Object.keys(views).forEach(function (k) { views[k].classList.toggle('is-on', views[k] === target); });
      }
      drawer.querySelectorAll('[data-tray]').forEach(function (el) {
        var key = el.getAttribute('data-tray');
        el.addEventListener('mouseenter', function () { show(key); });
        el.addEventListener('focus', function () { show(key); });
      });
      // revert to the campaign image only when the cursor leaves the whole tray (so trays stay clickable)
      var wrap = drawer.querySelector('.drawer-tray');
      if (wrap) wrap.addEventListener('mouseleave', function () { show('rest'); });
    });
  }

  /* ---- The Moon ordering window (§6): the one live element in the nav ---- */
  function primeMoon() {
    if (!window.COMoon || !window.COMoon.window || !window.COEURA_MOON) return;
    moonState = window.COMoon.window(window.COEURA_MOON);
    // mobile: permanent line under The Moon; desktop: the caption on the Moon family tray.
    // The footer moon line (.foot-moon) is owned by sections/footer.liquid — leave it alone.
    document.querySelectorAll('[data-moon-line]:not(.foot-moon), [data-moon-cap]').forEach(function (n) {
      n.textContent = moonState.line;
      n.classList.remove('cap-moon-open', 'cap-moon-closed');
      n.classList.add(moonState.open ? 'cap-moon-open' : 'cap-moon-closed');
    });
  }

  /* ---- Mobile menu (§9) ---- */
  function wireMobile() {
    var menu = document.querySelector('.mobile-menu');
    if (!menu) return;
    document.querySelectorAll('.menu-toggle:not([data-close])').forEach(function (b) {
      b.addEventListener('click', function () { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); });
    });
    var closeBtn = menu.querySelector('[data-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true');
    });
    // the mobile menu is flat (no accordions) — nothing else to wire here
  }

  /* ---- Gentle fades ---- */
  function watchFades() {
    var els = document.querySelectorAll('.fade');
    if (!('IntersectionObserver' in window)) { els.forEach(function (n) { n.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (n) { io.observe(n); });
    setTimeout(function () { document.querySelectorAll('.fade:not(.is-in)').forEach(function (n) { n.classList.add('is-in'); }); }, 1400);
  }

  function init() { wireDrawers(); wireTray(); wireMobile(); primeMoon(); watchFades(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
